import http from "../http";
import Service from "../../Service";
import StoreService from "../stores/store.service";

export default class VisitService extends Service {
    list(params) {
        return http.get("v2/clients/checkins", {
            headers: this.getHeaders(),
            params,
        });
    }

    options() {
        return new StoreService().load().then(({ data }) => {
            const stores = Array.isArray(data) ? data : data.data || [];
            return { data: { stores: stores.map((store) => ({ value: store.id, label: store.name })), providers: [], sellers: [] } };
        });
    }

    show(id) {
        return http.get(`v2/clients/checkins/${id}`, {
            headers: this.getHeaders(),
        });
    }

    create(payload) {
        return http.post("v2/clients/checkins", payload, {
            headers: this.getHeaders(),
        });
    }

    checkout(id, payload = {}) {
        return http.post(`v2/clients/checkins/${id}/checkout`, payload, {
            headers: this.getHeaders(),
        });
    }
}
